import api from 'Application/api/api';

const patchStep = (signal, stepId, status) =>
	api.patch(`/steps/set-status/${stepId}`, JSON.stringify(status), {
		signal,
	});

export default patchStep;
